import { request } from './request'

//上传图片、文件
export function getUserUpload(cover_image, progressEvent) {
  return request({
    url: 'https://kpc.cowsms.com/webapi/upload/image',
    method: "post",
    data: cover_image,
    timeout: 1000000,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: progressEvent
  })
}

//获取活动话题
export function getActivityKeywords() {
  return request({
    url: '/activity/keywords',
    method: "get",
  })
}

//发帖子
export function sendTopics(data) {
  return request({
    url: '/topics',
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: data
  })
}

